import { getNationalSalesPage, getGlobals } from "storyblok/api"
import Meta from "components/Meta"
import NationalSalesPage from "components/DynamicComponent/organisms/NationalSalesPage"

export default function NationalSales({ meta, story }) {
  return (
    <>
      <Meta info={meta} />
      <NationalSalesPage story={story} />
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const story = await getNationalSalesPage(preview)
  return {
    props: {
      story: story ?? null,
      meta: story?.page?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
